import { Mutator } from 'final-form'
import arrayMutators from 'final-form-arrays'

export const typedArrayMutatorsCreator = <FormValues, InitialFormValues>() =>
  arrayMutators as unknown as {
    concat: Mutator<FormValues, InitialFormValues>
    insert: Mutator<FormValues, InitialFormValues>
    move: Mutator<FormValues, InitialFormValues>
    pop: Mutator<FormValues, InitialFormValues>
    push: Mutator<FormValues, InitialFormValues>
    remove: Mutator<FormValues, InitialFormValues>
    removeBatch: Mutator<FormValues, InitialFormValues>
    shift: Mutator<FormValues, InitialFormValues>
    swap: Mutator<FormValues, InitialFormValues>
    unshift: Mutator<FormValues, InitialFormValues>
    update: Mutator<FormValues, InitialFormValues>
  }
